<ng-container *transloco="let t; prefix: 'PremiseHazardType'">
  @if (IsInitialized) {
    <div class="list-page-table-container">
      <div class="list-toolbar-row">
        <div class="list-toolbar-left">
          <button pButton [text]="true" class="msi-padding-s refresh-button" [disabled]="!AllowInteraction"
            [attr.aria-label]="t('List.refreshButton')" [pTooltip]="t('List.refreshButton')" (click)="refreshClicked()">
            <msi-icon name="ic_refresh" /> {{ 'Buttons.refresh' | transloco }}
          </button>
          <button pButton [text]="true" class="msi-padding-s load-more-button"
            [disabled]="!HasMoreResults || !AllowInteraction" (click)="loadNextPageClicked()">
            <msi-icon [name]="AllowInteraction ? 'ic_download' : 'ic_refresh'" />{{ LoadMoreText }}
          </button>
        </div>
        <div class="list-toolbar-right">
          <button pButton [outlined]="true" class="msi-padding-s" [disabled]="!AllowInteraction" (click)="addNewClicked()">
            <msi-icon name="ic_add" />{{ 'Buttons.add' | transloco }}
          </button>
        </div>
      </div>
      @if (PremiseHazardTypes !== undefined) {
        <div class="data-table-wrapper">
          <p-table
            #table
            class="scrolling-data-table"
            [value]="PremiseHazardTypes"
            [scrollable]="true"
            scrollHeight="flex"
            selectionMode="single"
            [selection]="SelectedPremiseHazardType"
            (onRowSelect)="onRowSelected($event.data)"
            dataKey="id"
          >
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" style="width: 320px;">{{ t('label.code') }}</th>
                <th scope="col">{{ t('label.description') }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-i="rowIndex">
              <tr [pSelectableRow]="row" [class.disabled-row]="!AllowInteraction">
                <td [appEllipsisTooltip]="row.code">{{ row.code }}</td>
                <td [appEllipsisTooltip]="row.description">{{ row.description }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </div>
  }
  @if (!IsInitialized) {
    <div style="justify-content: center;">
      <p-progress-spinner />
    </div>
  }
</ng-container>
